import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase, ActionIconListItem } from 'library/styles/icon';

export const getActiveItemBackground = ({ isActive, theme }) => (
  isActive ? `
      background: linear-gradient(45deg, ${theme.colors.violetLight}, ${theme.colors.blue});
  ` : ''
);

export const List = styled.ul`
  margin: 0;
  padding-left: 6px;
  list-style: none;
  color: ${Colors.violet};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Icon = styled(IconBase)``;

export const ListItem = styled(ActionIconListItem)`
  ${getActiveItemBackground};
  background-color: ${(props) => props.theme.colors.shade07};
  
  ${Icon} {
    color: ${({ isActive, theme }) => (isActive ? theme.colors.shade08 : 'inherit')};
  }
`;

export const Paragraph = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.shade03};
`;
